import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "base-title-button" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "add_circle", -1)
const _hoisted_3 = { class: "table table-hover align-top mt-4" }
const _hoisted_4 = { class: "border-dark border-bottom pb-2" }
const _hoisted_5 = { class: "border-dark border-bottom" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", null, " ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", null, " ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  colspan: 6,
  class: "fw-bold small text-uppercase text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_base_placeholder_table = _resolveComponent("base-placeholder-table")!
  const _component_CpsOverviewItem = _resolveComponent("CpsOverviewItem")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_BaseTitle, {
        title: _ctx.$t('priceCards'),
        mb: 4,
        "show-refresh-button": "",
        onRefresh: this.reloadContent
      }, {
        buttons: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_router_link, {
              to: {name: 'new-price-card'},
              class: "btn btn-hover icon-link"
            }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('add')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["title", "onRefresh"]),
      _createVNode(_component_AlertError2, {
        error: this.pageUI.getError()
      }, null, 8, ["error"]),
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("thead", _hoisted_4, [
          _createElementVNode("tr", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("th", null, _toDisplayString(_ctx.$t('name')), 1),
            _hoisted_7,
            _createElementVNode("th", null, _toDisplayString(_ctx.$t('created')), 1),
            _hoisted_8
          ])
        ]),
        _createElementVNode("tbody", null, [
          (!this.pageUI.isReady)
            ? (_openBlock(), _createBlock(_component_base_placeholder_table, {
                key: 0,
                "n-cols": 6
              }))
            : (!this.hasContentPages)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                  _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.$t('noResults')), 1)
                ]))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(this.fullContentPages, (fullContentPage) => {
                  return (_openBlock(), _createBlock(_component_CpsOverviewItem, {
                    key: fullContentPage.id,
                    "full-content-page": fullContentPage,
                    "can-move": true,
                    "can-change-type": false,
                    "can-change-on-homepage": false,
                    "detail-route-name": "edit-price-card-wysiwyg",
                    onCopy: this.copyContent,
                    onDelete: this.deleteContent,
                    onMove: this.moveContent,
                    onUpdateStatus: this.updateStatus
                  }, null, 8, ["full-content-page", "onCopy", "onDelete", "onMove", "onUpdateStatus"]))
                }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}